export enum SupplierVettingStatus {
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
  }
  